import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';

export function UpdateEncounterFormFields() {
  return (
    <ParentBlockSelectField
      fieldName="config.payload"
      label="Encounter"
      helperText={getSourceBlockNameHelperText('encounter')}
    />
  );
}
